module.exports = __webpack_public_path__ + "img/数据大屏.ac31e124.png";